export default "/assets/838558d00fbc9248.svg"